<template lang="html">
  <div class="voice-bot__container">
      <div class="voice-bot__column voice-bot__property">
          <div class="voice-bot__title voice-bot__title_big">
              {{ $tr('vacancy.voiceBot.sectionTitles.voiceSettings') }}
          </div>
          <div class="voice-bot__options-list">
              <div class="voice-bot__title voice-bot__title_smaller">
                  {{ $tr('vacancy.voiceBot.voice') }}
              </div>
              <div class="voice-bot__voices">
                  <input class="voice-bot__input" type="radio" id="voice-male" value="Male" v-model="gender">
                  <label for="voice-male"
                    class="voice-bot__voice voice-bot__voice_male"
                    :class="{'voice-bot__voice_male_active': (gender === 'Male')}"
                  ></label>

                  <input class="voice-bot__input" type="radio" id="voice-female" value="Female" v-model="gender">
                  <label for="voice-female"
                    class="voice-bot__voice voice-bot__voice_female"
                    :class="{'voice-bot__voice_female_active': (gender === 'Female')}"
                  ></label>
              </div>
          </div>
          <div class="voice-bot__options-list">

              <div
                class="voice-bot__title voice-bot__title_smaller voice-bot__title_collapsible"
                @click="toggleDropdownOption"
                :v-on-click-away="hideDropdownOption"
              >
                  <div
                    class="voice-bot__arrow"
                    :class="showDropdownMenu ? 'voice-bot__arrow_selected' : 'voice-bot__arrow_not-selected'"
                  ></div>
                  {{ $tr('vacancy.voiceBot.dialect.title') }}
              </div>

              <div
                class="voice-bot__dialect"
                :class="showDropdownMenu ? 'voice-bot__dialect_visible' : 'voice-bot__dialect_hidden'"
              >
                <div class="voice-bot__option">
                  <slider-row
                    :model="options[3]"
                    :selectedModel="getSelectedModel(options[3])"
                  ></slider-row>
                </div>
                <div class="voice-bot__option">
                  <slider-row
                    :model="options[2]"
                    :selectedModel="getSelectedModel(options[2])"
                  ></slider-row>
                </div>
              </div>
          </div>
      </div>
      <div class="voice-bot__column voice-bot__list">
          <div class="voice-bot__title voice-bot__title_big row-checkbox">
              {{ $tr('vacancy.voiceBot.sectionTitles.audioQuestions') }}
              <label class="custom-trigger">
                <input type="checkbox" v-model="voicebotState">
                <span class="custom-trigger__slider custom-trigger__round"></span>
              </label>
          </div>

          <question-list v-model="questions"></question-list>

          <button @click="addQuestion" class="vcv-button green voice-bot__btn">
            {{ $tr('vacancy.voiceBot.newQuestion') }}
          </button>
      </div>
  </div>
</template>

<script>
import debounce from 'debounce'

import { directive as VueClickAway } from 'vue-clickaway'

import QuestionList from './questions/List.vue'

import CustomCheckbox from '@/components/shared/Checkbox.vue'
import CustomTrigger from '@/components/shared/Trigger.vue'
import SliderRow from './options/SliderRow.vue'

import store from '@/store'

export default {
  name: 'preferences-voice-bot',

  components: {
    CustomCheckbox,
    CustomTrigger,
    SliderRow,
    QuestionList
  },

  directives: {
    onClickAway: VueClickAway
  },

  props: {
    vacancyId: String
  },

  data () {
    return {
      value: null,
      showDropdownMenu: true
    }
  },

  methods: {
    fetch () {
      this.vacancyId && this.$store.dispatch('vacancy/voicebot/fetch', {
        vacancyId: this.vacancyId
      })
    },

    addQuestion () {
      this.$store.commit('vacancy/voicebot/addQuestion', this.voicebot)
    },

    saveVoicebot: debounce(function () {
      this.$store.dispatch('vacancy/voicebot/save', this.voicebot)
    }, 1000),

    getSelectedModel (model) {
      return this.selectedOptions.filter(item => item.id === model.id)[0]
    },

    toggleDropdownOption () {
      this.showDropdownMenu = !this.showDropdownMenu
    },

    hideDropdownOption () {
      this.showDropdownMenu = false
    }
  },

  computed: {
    loading () {
      return this.$store.getters['vacancies/voicebot/loading']
    },

    vacancy () {
      return this.$store.getters['vacancy/one']
    },

    voicebot () {
      return this.$store.getters['vacancy/voicebot/one']
    },

    selectedOptions () {
      return this.$store.getters['vacancy/voicebot/selectedOptions']
    },

    options () {
      return this.$store.getters['vacancy/voicebot/options']
    },

    gender: {
      get () {
        return this.selectedOptions[1]
          ? this.selectedOptions[1].values[0].name
          : undefined
      },

      set (val) {
        const model = this.getSelectedModel(this.options[1])
        this.$store.commit('vacancy/voicebot/updateOption', {
          model: model,
          data: {
            values: [ { name: val, id: val } ]
          }
        })
        // this.saveVoicebot()
      }
    },

    route () {
      return this.$store.getters['vacancy/voicebot/route']
    },

    questions: {
      get () {
        return this.voicebot.questions
      },

      set (questions) {
        // NOTE: look like that backend doesnt't reordering questions, and return its ordered by id on the next request
        this.$store.dispatch('vacancy/voicebot/updateQuestions', { questions })
      }
    },

    voicebotState: {
      get () {
        return this.voicebot.is_active
      },

      set (state) {
        (state
          ? this.$store.dispatch('vacancy/voicebot/enable', this.voicebot)
          : this.$store.dispatch('vacancy/voicebot/disable', this.voicebot))
          .then(() => this.$store.dispatch('vacancy/fetch', {id: this.vacancyId}))
      }
    }
  },

  mounted () {
    this.$parent.$on('save', this.saveVoicebot)
  },

  destroyed () {
    this.$parent.$off('save')
  },

  beforeRouteEnter (to, from, next) {
    return Promise.all([
      store.dispatch('vacancy/voicebot/fetch', { vacancyId: to.params.id })
    ]).then(() => next())
  },

  beforeMount () {
    // this.fetch()

    if (this.voicebot.questions) {
      this.$store.dispatch('vacancy/voicebot/initAudio', this.voicebot.options)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .voice-bot__container {
    display: flex;
    margin-bottom: 20px;
  }

  .voice-bot__column {
    display: flex;
    flex-direction: column;
    margin-right: 30px;
  }

  .voice-bot__property {
    width: 170px;
    background-color: #fafafa;
    padding: 10px 10px 0 10px;
  }

  .voice-bot__list {
    width: 90%;
    align-items: flex-start;
  }

  .voice-bot__column:last-child {
    margin-right: 0;
  }

  .voice-bot__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    color: #333333;
  }

  .voice-bot__title_big {
    font-size: 22px;
    margin-bottom: 15px;
  }

  .voice-bot__title_collapsible {
    justify-content: flex-start;
    font-size: 16px;
    padding-bottom: 5px;
    border-bottom: 1px solid #ccc;
    margin-bottom: 30px;
    cursor: pointer;
    opacity: 0.65;
    transition: opacity 0.7s;
  }

  .voice-bot__title_collapsible:hover {
    opacity: 1;
  }

  .voice-bot__arrow {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 7px solid #b5b5b5;
    transition: all 0.3s;
    margin-right: 10px;
  }

  .voice-bot__arrow_not-selected {
    transform: rotate(0deg);
  }

  .voice-bot__arrow_selected {
    transform: rotate(180deg);
  }

  .voice-bot__title_smaller {
    font-size: 16px;
    margin-bottom: 15px;
  }

  .voice-bot__title_dark {
    color: #333;
  }

  .voice-bot__voice {
    width: 36px;
    height: 36px;
    border-radius: 20px;
    margin-right: 10px;
    transition: all 0.3s;
    cursor: pointer;
  }

  .voice-bot__voice_male {
    background: url(/static/images/elements/man.png) no-repeat center;
  }

  .voice-bot__voice_male:hover {
    background: url(/static/images/elements/man_selected.png) no-repeat center;
  }

  .voice-bot__voice_male_active {
    background: url(/static/images/elements/man_selected.png) no-repeat center;
  }

  .voice-bot__voice_female {
    background: url(/static/images/elements/woman.png) no-repeat center;
  }

  .voice-bot__voice_female:hover {
    background: url(/static/images/elements/woman_selected.png) no-repeat center;
  }

  .voice-bot__voice_female_active {
    background: url(/static/images/elements/woman_selected.png) no-repeat center;
  }

  .voice-bot__options-list {
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
    z-index: 10;
  }

  .voice-bot__options-list:last-child {
    margin-bottom: 0;
  }

  .voice-bot__emotions {
    height: 115px;
    overflow-y: auto;
  }

  .voice-bot__emotion {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .voice-bot__emotion:last-child {
    margin-bottom: 0;
  }

  .voice-bot__voices {
    display: flex;
  }

  .voice-bot__dialect {
    display: flex;
    flex-direction: column;
    font-size: 15px;
    margin-bottom: 20px;
    transition: all 0.7s;
  }

  .voice-bot__option {
    margin-bottom: 30px;
  }

  .voice-bot__option:last-child {
    margin-bottom: 0;
  }

  .voice-bot__dialect_visible {
    transform: translateY(0);
    z-index: 1;
    opacity: 1;
  }

  .voice-bot__dialect_hidden {
    transform: translateY(-25px);
    opacity: 0;
    z-index: -9999;
  }

  .voice-bot__range {
    position: relative;
    border: 23px solid transparent;
    border-bottom: 0 solid transparent;
    border-left: 0 solid transparent;
    border-right: 120px solid #cbcbcb;
    cursor: pointer;
  }

  .voice-bot__range:after {
    content: '';
    display: block;
    position: absolute;
    width: 14px;
    height: 29px;
    top: -23px;
    left: 5px;
    border-radius: 6.6px;
    background-color: #ffffff;
    border: solid 1px #aaaaaa;
    cursor: pointer;
  }

  .voice-bot__btn {
    margin-left: 0;
  }

  .voice-bot__multiselect {
    display: inline-block;
    width: 20%;
    margin-right: 10px;
  }

  .voice-bot__input {
    display: none;
  }

  .custom-trigger {
    position: relative;
    display: inline-block;
    width: 78px;
    height: 32px;
    margin-bottom: 0;
    font-size: 11.7px !important;
  }

  .custom-trigger input {
    display: none;
  }

  .custom-trigger__slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #e8e8e8;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .custom-trigger__slider:before {
    position: absolute;
    content: 'OFF';
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 52px;
    height: 32px;
    left: 0;
    bottom: 0;
    background-color: #adadad;
    transition: 0.4s;
  }

  input:checked + .custom-trigger__slider {
    background-color: #e8e8e8;
  }

  input:focus + .custom-trigger__slider {
    box-shadow: 0 0 1px #e8e8e8;
  }

  input:checked + .custom-trigger__slider:before {
    content: 'ON';
    transform: translateX(26px);
    background-color: $green;
  }

  .custom-trigger__slider.custom-trigger__round {
    border-radius: 16px;
  }

  .custom-trigger__slider.custom-trigger__round:before {
    border-radius: 16px;
  }

  @media screen and (max-width: 1199px) {
    .voice-bot {
      width: 740px;
    }
  }
</style>
